import React, { useState } from "react";
import PropTypes from "prop-types";
import { compose, withProps, withState } from "recompose";
import Button from "theme/components/atoms/Button";
import Icon from "theme/components/atoms/Icon";
import { FormattedMessage } from "react-intl";

import Checkbox from "theme/components/atoms/Form/Input/Checkbox";

const Option = ({
  option,
  isChecked,
  setIsChecked,
  onChange,
  payloadOnClick,
  newValues,
}) => {
  return (
    <Checkbox
      name={option.value}
      id={option.value}
      label={option.label}
      checked={isChecked}
      inverted="true"
      onChange={() => {
        setIsChecked(!isChecked);
        onChange(payloadOnClick, newValues);
      }}
      darker="true"
    />
  );
};

const EnhancedOption = compose(
  withProps((props) => {
    return {
      isSelected:
        props.currentValues &&
        props.currentValues.indexOf(props.option.value) !== -1,
    };
  }),
  withState("isChecked", "setIsChecked", (props) => props.isSelected)
)(Option);

const OptionPicker = ({
  label,
  options,
  name,
  currentValues,
  onChange,
  labelRenderer,
  limitBy = false,
}) => {
  const [currentLimitBy, setlimitBy] = useState(limitBy);
  let isSelected = null;
  const optionsView = options
    .map((option, index) => {
      if (currentLimitBy && currentLimitBy !== -1 && currentLimitBy <= index) {
        return false;
      }
      currentValues &&
        (isSelected = currentValues.indexOf(option.value) !== -1);

      let newValues = [];
      if (isSelected) {
        newValues = currentValues.filter((value) => value !== option.value);
      } else {
        newValues = currentValues.concat(option.value);
      }

      const payloadOnClick = {
        [name]: newValues,
      };

      return (
        <div className="checkbox-wrapper" key={option.value}>
          <EnhancedOption
            currentValues={currentValues}
            option={option}
            onChange={onChange}
            payloadOnClick={payloadOnClick}
            newValues={newValues}
          />
        </div>
      );
    })
    .filter(Boolean);

  return (
    <div className="option-picker">
      {label && <div>{label}</div>}
      {labelRenderer && labelRenderer({ options: options })}
      <input
        name={name}
        id={name}
        type="hidden"
        value={currentValues ? currentValues : null}
      />
      {optionsView}
      {currentLimitBy &&
        currentLimitBy !== -1 &&
        options.length > currentLimitBy && (
          <Button
            appearance="icon"
            title={"show more"}
            onClick={() => {
              setlimitBy(-1);
            }}
          >
            <Icon icon={"chevron-down"} size={"mini"} title={"show more"} />
            <span>
              <FormattedMessage
                id="components.molecules.OptionPicker.showMore"
                defaultMessage="Show more"
              />
            </span>
          </Button>
        )}
      {currentLimitBy && currentLimitBy === -1 && (
        <Button
          appearance="icon"
          title={"show less"}
          onClick={() => {
            setlimitBy(limitBy);
          }}
        >
          <Icon icon={"chevron-up"} size={"mini"} title={"show less"} />
          <span>
            <FormattedMessage
              id="components.molecules.OptionPicker.showLess"
              defaultMessage="Show less"
            />
          </span>
        </Button>
      )}
    </div>
  );
};

OptionPicker.propTypes = {
  options: PropTypes.array.isRequired,
  shape: PropTypes.string,
  label: PropTypes.string,
  labelRenderer: PropTypes.func,
};

export default OptionPicker;
